import { render } from "./QuanTriNhanSu.vue?vue&type=template&id=4860dee6&scoped=true"
import script from "./QuanTriNhanSu.vue?vue&type=script&lang=js"
export * from "./QuanTriNhanSu.vue?vue&type=script&lang=js"

import "./QuanTriNhanSu.vue?vue&type=style&index=0&id=4860dee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4860dee6"]])

export default __exports__